import React from "react";
import Box from "@material-ui/core/Box";
import LinkMui from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "./../util/router";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "0.875rem",
    textAlign: "center",
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.12)"
        : theme.palette.divider
    }`,
    color:
      theme.palette.type === "dark"
        ? "rgba(255, 255, 255, 0.7)"
        : theme.palette.text.secondary,
  },
  link: {
    fontWeight: 500,
    color:
      theme.palette.type === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.main,
    transition: theme.transitions.create("color"),
    "&:hover": {
      color:
        theme.palette.type === "dark"
          ? theme.palette.primary.main
          : theme.palette.primary.dark,
      textDecoration: "none",
    },
  },
  spacerSmall: {
    display: "inline-block",
    width: theme.spacing(1),
  },
  spacerMedium: {
    display: "inline-block",
    width: theme.spacing(2),
  },
  agreement: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
}));

function AuthFooter(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {props.type === "signup" && (
        <>
          {props.showAgreement && (
            <Box className={classes.agreement}>
              By signing up, you are agreeing to our{" "}
              <LinkMui
                className={classes.link}
                component={Link}
                to={props.termsPath}
              >
                Terms of Service
              </LinkMui>{" "}
              and{" "}
              <LinkMui
                className={classes.link}
                component={Link}
                to={props.privacyPolicyPath}
              >
                Privacy Policy
              </LinkMui>
              .
            </Box>
          )}

          {props.signinText}
          <span className={classes.spacerSmall} />
          <LinkMui
            className={classes.link}
            component={Link}
            to={props.signinPath}
          >
            {props.signinAction}
          </LinkMui>
        </>
      )}

      {props.type === "signin" && (
        <>
          <LinkMui
            className={classes.link}
            component={Link}
            to={props.signupPath}
          >
            {props.signupAction}
          </LinkMui>

          {props.forgotPassAction && (
            <>
              <span className={classes.spacerMedium} />
              <LinkMui
                className={classes.link}
                component={Link}
                to={props.forgotPassPath}
              >
                {props.forgotPassAction}
              </LinkMui>
            </>
          )}
        </>
      )}

      {props.type === "forgotpass" && (
        <>
          {props.signinText}
          <span className={classes.spacerSmall} />
          <LinkMui
            className={classes.link}
            component={Link}
            to={props.signinPath}
          >
            {props.signinAction}
          </LinkMui>
        </>
      )}
    </div>
  );
}

export default AuthFooter;
